import { gql } from "@apollo/client";

export const ES_NUTRICIONISTA = gql`
  query isTipoProfesionalNutricionista {
    isTipoProfesionalNutricionista 
}`;